import { FC, useEffect, useState } from "react";
import { ChatFileImageProps } from "./types";
import { HOST_CHAT_FILES } from "../../../../../../api";
import { ChatStatus } from "../../../../../../types";
import { Column } from "../../../../../../components/containers";
import { useChatStore, useThemeStore } from "../../../../../../stores";
import ProgressBar from "../../../../../../components/progress-bar";
import { IconAnimation } from "../../../../../../components/animation";
import { DownloadIcon } from "../../../../../../assets/icons";
import { JustifyContent } from "../../../../../../components/containers/types";

const ChatFileImage: FC<ChatFileImageProps> = ({
  file,
  status,
  isSidePanel,
}) => {
  const theme = useThemeStore((s) => s.theme);
  const loadedImgs = useChatStore((s) => s.loadedImgs);
  const isImgLoaded = useChatStore((s) => s.isImgLoaded);
  const imgLoaded = useChatStore((s) => s.imgLoaded);

  const IMAGE_PLACEHOLDER = !file.local
    ? `${HOST_CHAT_FILES}/${file.thumbnail}`
    : "";

  const [src, setSrc] = useState<string>(IMAGE_PLACEHOLDER);

  const [opacity, setOpacity] = useState<number>(1);

  const openFileInNewTab = () => {
    window.open(
      !file.local ? `${HOST_CHAT_FILES}/${file.filename}` : file.name
    );
  };

  useEffect(() => {
    let interval: NodeJS.Timer;

    if (status === ChatStatus.Waiting) {
      interval = setInterval(() => {
        setOpacity((prev) => (prev === 1 ? 0.3 : 1));
      }, 600);
    }

    return (): void => {
      clearInterval(interval);
    };
  }, [status]);

  useEffect(() => {
    if (isImgLoaded(!file.local ? file.filename : file.realName))
      setSrc(!file.local ? `${HOST_CHAT_FILES}/${file.filename}` : file.name);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadedImgs]);

  const downloadImg = (): void => {
    const img = document.createElement("img");

    img.src = !file.local ? `${HOST_CHAT_FILES}/${file.filename}` : file.name;

    img.onload = () => {
      setSrc(!file.local ? `${HOST_CHAT_FILES}/${file.filename}` : file.name);

      imgLoaded(!file.local ? file.filename : file.realName);

      img.remove();
    };
  };

  return (
    <Column
      style={{
        width: "100%",
        maxWidth: 400,
      }}
      gap={8}
    >
      <Column
        style={{
          position: "relative",
          overflow: "hidden",
          borderRadius: 15,
          width: "100%",
        }}
      >
        <img
          src={src}
          alt={!file.local ? file.filename : file.name}
          style={{
            width: "100%",
            borderRadius: 15,
            cursor: "pointer",
            opacity,
          }}
          onClick={openFileInNewTab}
          className="transition-slow"
        />

        <Column
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backdropFilter: "blur(20px)",
            display: src === IMAGE_PLACEHOLDER ? "flex" : "none",
          }}
          justifyContent={JustifyContent.Center}
        >
          <IconAnimation
            Icon={DownloadIcon}
            onHoverColor={theme.primary}
            width={30}
            height={30}
            style={{
              cursor: "pointer",
            }}
            onClick={downloadImg}
          />
        </Column>
      </Column>

      <ProgressBar
        filename={file.local ? file.realName : ""}
        background={isSidePanel ? theme.overlay : theme.background}
      />
    </Column>
  );
};

export default ChatFileImage;
